import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 3h10v4h-10z","key":"svg-0"}],["path",{"d":"M12 7v4","key":"svg-1"}],["path",{"d":"M12 11a2 2 0 0 1 2 2v6a2 2 0 1 1 -4 0v-6a2 2 0 0 1 2 -2z","key":"svg-2"}]]

const IconRazor = createReactComponent('outline', 'razor', 'Razor', __iconNode);

export default IconRazor;